import Box from '@mui/material/Box';
import ContactFormMUI from '../components/ContactForm';

import '../css/contact.scss';
import { Link } from 'react-router';

const Contact = () => {

  return (
    <Box id="contact">
      <div id="title">
        <h1>CONTACT</h1>
      </div>
      <Box className="jumbo"
      sx={(theme) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#6F6F6F' : '#EFEFEF',
        color: '#CA8E4C',
      })}>
        <div className="flex content-width">
          <div className="jumbo-left">
            <p className="footer-phone"><span className="icon phone-out" /> 0473/19.94.70</p>
              <img src="images/rappel.png" alt="Bouton on vous rappelle gratuitement" />
          </div>
          <div className="jumbo-right">
            <p><span className="icon mail-open" /> Email</p>
            <span className="footer-mail"> <a href="mailto:info@koffi.be">info@koffi.be</a></span><br />
          </div>
        </div>
      </Box>
      <Box className="contact-pro"
      sx={(theme) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#AA4A4A' : '#FCACAC',
        color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
      })}>
        <h1>Si vous êtes un contact professionnel et désirez une facture pour la TVA :</h1>
        <Link to="/contact-pro">
              <img src="images/rdvpro.png" alt="Allez sur la page PRO" />
        </Link>
      </Box>
      <ContactFormMUI />
    </Box>
  )
};

export default Contact;
